import CatalogSorting from '~/themes/base/components/catalog/CatalogSorting'

export default {
  extends: CatalogSorting,
}
